import React from "react";

import TradeVerticalPage from "../../../components/admin/Dashboard/trade/TradeVerticalPage";
import { TRADE_VERTICALS } from "../../../constants/tradeVerticals";

const TradeFinance = () => <TradeVerticalPage config={TRADE_VERTICALS.finance} />;

export default TradeFinance;
